/** URL canónica del sitio (coincide con public/sitemap.xml). */
export const SITE_BASE_URL = "https://www.metaslogopedia.es";

/** Metadatos por ruta: título (~50–60 caracteres) y meta descripción (~150–160). */
export const SEO = {
  home: {
    title:
      "Metas Logopedia A Coruña | Centro de logopedas y terapia del lenguaje",
    description:
      "Centro de logopedia en A Coruña: trastornos del lenguaje, habla, comunicación y deglución. Atención a niños y adultos, logopedas colegiadas. Entrevista inicial gratuita en el centro de la ciudad.",
    path: "/",
  },
  equipo: {
    title: "Equipo de logopedas en A Coruña | Metas Centro de Logopedia",
    description:
      "Conoce al equipo de Metas: logopedas colegiadas en A Coruña con experiencia en atención temprana, gerontología, lactancia y rehabilitación del lenguaje. Citas e información en el centro de la ciudad.",
    path: "/equipo",
  },
  servicios: {
    title: "Servicios de logopedia en A Coruña | Niños y adultos – Metas",
    description:
      "Servicios de logopedia para niños y adultos en A Coruña: evaluación, intervención y seguimiento en lenguaje, habla, voz, deglución y lectoescritura. Solicita información sin compromiso.",
    path: "/servicios",
  },
  serviciosNinos: {
    title: "Logopedia infantil en A Coruña | Áreas de intervención – Metas",
    description:
      "Intervención logopédica infantil en A Coruña: lenguaje, habla, lectoescritura, deglución, voz y más. Metas Centro de Logopedia, equipo colegiado y plan personalizado para cada niño o niña.",
    path: "/servicios/ninos",
  },
  serviciosAdultos: {
    title: "Logopedia para adultos en A Coruña | Metas Centro de Logopedia",
    description:
      "Logopedia para adultos en A Coruña: estimulación cognitiva, habla, voz, deglución, disfagia y patologías neurodegenerativas. Valoración e intervención adaptada en Metas Logopedia.",
    path: "/servicios/adultos",
  },
  blog: {
    title: "Blog de logopedia | Noticias y recursos – Metas A Coruña",
    description:
      "Blog de Metas Centro de Logopedia: artículos y recursos sobre lenguaje, habla, comunicación y salud. Actualidad desde nuestro centro de logopedia en A Coruña.",
    path: "/blog",
  },
  contacto: {
    title: "Contacto con logopedas en A Coruña | Metas Logopedia",
    description:
      "Contacta con Metas Logopedia en A Coruña: formulario, teléfono 604 077 457, email y ubicación en Rúa Magistrado Manuel Artime. Te informamos sobre servicios y citas.",
    path: "/contacto",
  },
  metodologia: {
    title: "Metodología de intervención logopédica | Metas A Coruña",
    description:
      "Cómo trabajamos en Metas: entrevista gratuita, evaluación, comunicación del informe, intervención personalizada y seguimiento. Proceso claro para pacientes y familias en A Coruña.",
    path: "/metodologia",
  },
  avisoLegal: {
    title: "Aviso legal | Metas Centro de Logopedia A Coruña",
    description:
      "Aviso legal de Metas Centro de Logopedia: datos identificativos, condiciones de uso del sitio web y normativa aplicable (LSSI). Centro de logopedia en A Coruña.",
    path: "/aviso-legal",
  },
  proteccionDatos: {
    title: "Protección de datos y privacidad | Metas Logopedia",
    description:
      "Política de privacidad de Metas Logopedia: tratamiento de datos personales, derechos del interesado y medidas de seguridad conforme al RGPD. Información para pacientes y visitantes.",
    path: "/proteccion-datos",
  },
  cookies: {
    title: "Política de cookies | Metas Centro de Logopedia",
    description:
      "Uso de cookies en metaslogopedia.es: tipos de cookies, finalidad y cómo gestionarlas. Metas Centro de Logopedia, servicios de logopedia en A Coruña.",
    path: "/cookies",
  },
};
